import { render, staticRenderFns } from "./PropertyListFormEdit.vue?vue&type=template&id=97b51928&"
import script from "./PropertyListFormEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyListFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports